/* eslint-disable max-lines */
import React, {useEffect, useMemo, useState} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table, Dropdown, Input, Modal, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import '../styles/styles.scss';
import {mapColorsToDropdownList, mapModelsToDropdownList} from '../utils';
import CurrencyInput from 'react-currency-input-field';

const sumValues = ({fl, cl, ch, cb, tcomercial, it, ty, tde, tdedp, tc}) => {
  return ((parseInt(fl, 10) || 0) + (parseInt(cl, 10) || 0) +
  (parseInt(ch, 10) || 0) + (parseInt(cb, 10) || 0) + (parseInt(tcomercial, 10) || 0) +
  (parseInt(it, 10) || 0) + (parseInt(ty, 10) || 0) + (parseInt(tde, 10) || 0) + (parseInt(tdedp, 10) || 0) +
  (parseInt(tc, 10) || 0));
};

const handleInputText = (row, handleChange, data, value, keyValue) => {
  if (data) {
    const newData = [...data];
    Object.assign(newData[row.index], {[keyValue]: value});
    Object.assign(newData[row.index], {'total': sumValues(newData[row.index])});
    handleChange({...newData[row.index]});
  }
};

const originsTableHeaderWithProps = (
  {
    dataValue,
  },
  {
    handleChange,
    removeTempOrder,
    listCatalog,
    fetchGetTempOrderColor,
    fetchGetTempOrderPrice,
  }) => {
  const dataCloned = cloneDeep(dataValue);
  return [
    {
      'Header': () => <span className="header-title">MODELO</span>,
      'accessor': 'model',
      'className': 'width-temp-order-big dropdown-cell cell-fixed-size',
      'Cell': ({row}) => {
        const [colors, setColors] = useState(null);
        const [valueAndKey, setValueAndKey] = useState(null);

        useEffect(() => {
          if (colors) {
            handleInputText(row, handleChange, dataCloned, mapColorsToDropdownList(colors), valueAndKey.keyValue);
          }
        }, [colors]);

        useEffect(() => {
          if (valueAndKey) {
            fetchGetTempOrderColor(valueAndKey.katashiki, valueAndKey.sfx, setColors);
          }
        }, [valueAndKey]);
        return (
          <div>
            <Dropdown
              placeholder="Buscar modelo ..."
              fluid
              selection
              search
              value={row.original.sfxAndModel}
              onChange={(e, {value}) => {
                const [sfx, katashiki] = value.split('&') || ['', ''];
                handleInputText(row, handleChange, dataCloned, sfx, 'sfx');
                handleInputText(row, handleChange, dataCloned, katashiki, 'model');
                handleInputText(row, handleChange, dataCloned, value, 'sfxAndModel');
                setValueAndKey({sfx, katashiki, 'keyValue': 'avaliableColors'});
              }
              }
              options={listCatalog || []}
            />
          </div>
        );
      },
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO - INTERNO</span>,
      'accessor': 'colors',
      'className': 'width-temp-order-medium dropdown-cell cell-fixed-size',
      'Cell': ({row}) => {
        const [price, setPrice] = useState(null);
        const [valuesAndKeys, setValuesAndKeys] = useState(null);

        useEffect(() => {
          if (price) {
            handleInputText(row, handleChange, dataCloned, price, valuesAndKeys.keyValue);
          }
        }, [price]);

        useEffect(() => {
          if (valuesAndKeys) {
            fetchGetTempOrderPrice(valuesAndKeys, setPrice);
          }
        }, [valuesAndKeys]);
        return (
          <div>
            <Dropdown
              placeholder="Buscar colores ..."
              fluid
              selection
              search
              value={row.original.colors}
              onChange={(e, {value}) => {
                const colors = value.split('-') || ['', ''];
                const colorsText = row.original.avaliableColors.find((color) => color.key === value);
                const colorsTextValues = colorsText?.text.split('-');
                handleInputText(row, handleChange, dataCloned, colors[0], 'externalcolor');
                handleInputText(row, handleChange, dataCloned, colors[1], 'internalcolor');
                handleInputText(row, handleChange, dataCloned, colorsTextValues[0], 'externalColorDescription');
                handleInputText(row, handleChange, dataCloned, colorsTextValues[1], 'internalColorDescription');
                handleInputText(row, handleChange, dataCloned, value, 'colors');
                setValuesAndKeys({
                  'outColor': colors[0],
                  'inColor': colors[1],
                  'orderNumber': row.original.orderNumber,
                  'model': row.original.model,
                  'sfx': row.original.sfx,
                  'keyValue': 'price',
                });
              }}
              options={row.original.avaliableColors || []}
            />
          </div>
        );
      },
      
    },
    {
      'Header': () => <span className="header-title">PRECIO</span>,
      'accessor': 'price',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <div className='ui input input-price'>
              <CurrencyInput
                prefix="$ "
                decimalSeparator=","
                groupSeparator="."
                decimalsLimit={2}
                value={row.original.price || ''}
                onValueChange={(value, name) =>
                  parseFloat(value) < 100000.00 && handleInputText(row, handleChange, dataCloned, value, 'price')
                }
              />
            </div>
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO</span>,
      'accessor': 'externalColorDescription',
      'className': 'width-temp-order-medium cell-fixed-size',
    },
    {
      'Header': () => <span className="header-title">COLOR INTERNO</span>,
      'accessor': 'internalColorDescription',
      'className': 'width-temp-order-medium cell-fixed-size',
    },
    {
      'Header': () => <span className="header-title">UNIDADES TOTALES</span>,
      'accessor': 'total',
      'className': 'width-temp-order-small cell-fixed-size',
    },
    {
      'Header': () => <span className="header-title">FL</span>,
      'accessor': 'fl',
      'className': 'width-temp-order-small cell-fixed-size',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.fl}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'fl')
              }
              className="header-input"
            />
          </>
        );
      },

    },
    {
      'Header': () => <span className="header-title">DP</span>,
      'accessor': 'tdedp',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.tdedp}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'tdedp')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">TDE</span>,
      'accessor': 'tde',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.tde}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'tde')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">CL</span>,
      'accessor': 'cl',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.cl}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'cl')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">CH</span>,
      'accessor': 'ch',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.ch}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'ch')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">CB</span>,
      'accessor': 'cb',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.cb}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'cb')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">TC</span>,
      'accessor': 'tcomercial',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.tcomercial}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'tcomercial')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">IT</span>,
      'accessor': 'it',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.it}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'it')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">TY</span>,
      'accessor': 'ty',
      'className': 'width-temp-order-small',
      'Cell': ({row}) => {
        return (
          <>
            <Input
              value={row.original.ty}
              onChange={(e, {value}) =>
                handleInputText(row, handleChange, dataCloned, value, 'ty')
              }
              className="header-input"
            />
          </>
        );
      },
    },
    {
      'id': 'actions',
      'Header': () => <span className='header-title'>ACCIONES</span>,
      'className': 'width-temp-order-small',
      'disableFilters': true,
      'Cell': ({row}) => {
        const handleDeleteOrigin = () => {
          removeTempOrder(row.original.id);
        };
        return (
          <>
            <Modal
              size={'mini'}
              trigger={
                <span className="link">
                  <Popup
                    trigger={
                      <span className="link">
                        <i className="material-icons">
                          {'delete'}
                        </i>
                      </span>
                    }
                    content="Eliminar"
                    position="top center"
                    inverted
                  />
                </span>
              }
              header="¿Está seguro que desea eliminar esta fila?"
              actions={[
                {'key': 'cancel', 'content': 'Cancelar'},
                {
                  'key': 'done',
                  'content': 'Confirmar',
                  'positive': true,
                  'onClick': () => handleDeleteOrigin(),
                  'primary': true,
                },
              ]}
            />
          </>
        );
      },
    },
  ];
};

const AddOrderTable = ({
  dataTable,
  handleChange,
  removeTempOrder,
  tempOrders,
  listCatalog,
  fetchGetTempOrderColor,
  fetchGetTempOrderPrice,
}) => {
  const clone = cloneDeep(dataTable);
  const columnsTable = originsTableHeaderWithProps(
    {
      'dataValue': tempOrders,
    },
    {
      handleChange,
      removeTempOrder,
      'listCatalog': mapModelsToDropdownList(listCatalog || []),
      fetchGetTempOrderColor,
      fetchGetTempOrderPrice,
    }
  );
  const data = useMemo(() => clone, [dataTable]);
  const columns = useMemo(() => columnsTable, [dataTable.length]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
  } = useTable(
    {
      columns,
      data,
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-container">
        <Table className="interactive table-custom" compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" className='dropdown-cell' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  return (
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign="center"
                      className={column.className}
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell>
                  );
                })}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()} className='body-add-line-table'>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} className='row-custom'>
                    {row.cells.map((cell, j) => {
                      return (
                        <Table.Cell
                          className={cell.column.className}
                          textAlign="center"
                        >
                          {<div>{cell.render('Cell')}</div>}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'tempOrders': state.manageOrders.tempOrders,
    'listCatalog': state.manageOrders.listCatalog,
  };
};


const {activateOrigin,
  fetchDeleteOrigin,
  fetchOrigins,
  fetchGetTempOrderColor,
  fetchGetTempOrderPrice,
  removeTempOrder,
  setOrderPrice,
} =
  Actions;

export default connect(mapStateToProps, {
  activateOrigin,
  fetchDeleteOrigin,
  fetchOrigins,
  fetchGetTempOrderColor,
  fetchGetTempOrderPrice,
  removeTempOrder,
  setOrderPrice,
})(AddOrderTable);
